module.exports = __webpack_public_path__ + "img/cv_back.e35c4682.png";